<template>
  <div :class="$style.container">
    <div :class="$style.header">
      Hardware
    </div>
    <div :class="$style.main">
      <ul :class="$style.infoList">
        <li :class="$style.infoListItem">
          <span>OS</span>
          <span>{{ os }}</span>
        </li>
        <li :class="$style.infoListItem">
          <span>OS Version</span>
          <span>{{ version }}</span>
        </li>
        <li :class="$style.infoListItem">
          <span>Architecture</span>
          <span>{{ systemInfo.cpu_type || unknown }}</span>
        </li>
      </ul>
      <ul :class="$style.infoList">
        <li :class="$style.infoListItem">
          <span>Vendor</span>
          <span>{{ systemInfo.hardware_vendor || unknown }}</span>
        </li>
        <li :class="$style.infoListItem">
          <span>Model</span>
          <span>{{ systemInfo.hardware_model || unknown }}</span>
        </li>
        <li :class="$style.infoListItem">
          <span>Serial Number</span>
          <span>{{ item.serialNumber || unknown }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Constants, { ItemTypeConsts, StoreModelMap } from 'client/util/Constants';
import SystemInsightsApi from 'client/api/v2/SystemInsightsApi';
import SystemInsightsComponentMixin from '../mixins/SystemInsightsComponentMixin';

const storeModel = StoreModelMap[ItemTypeConsts.system];

const { unknown } = Constants;

export default {
  name: 'HardwareInsights',
  mixins: [SystemInsightsComponentMixin],

  data: () => ({
    os: 'Unknown',
    unknown,
    version: 'Unknown',
  }),

  computed: {
    ...mapGetters(storeModel, [
      'isWindows',
    ]),
  },

  created() {
    SystemInsightsApi.getSystemInsight(this.item.id, 'os_version')
      .then((resp) => {
        if (resp.data && resp.data.length) {
          const info = resp.data[0];
          this.os = info.name || this.unknown;
          const { osVersionDetail } = this.item;

          this.version = this.formatOsVersionValue(info, osVersionDetail);
        }
      });
  },
};
</script>

<style module>
@import '../css/systemInsights.css';

@value (max-width-x-large) from '~css/breakpoints.css';

/*
 * NOTE: This superfluous CSS rule-set is added so that there is _something_ before the @media
 * block. If the CSS doesn't have any rule-sets _before_ an @media block then an error, similar to
 * the following, will be seen when this component is processed by vue-jest.
 *
 *
 * FAIL  test/components/GetStartedInstructions/GetStartedInfo.test.js
 * ● Test suite failed to run
 *   undefined:140:3: missing '}'
 *     at error (node_modules/extract-from-css/node_modules/css/lib/parse/index.js:62:15)
 *     at declarations (node_modules/extract-from-css/node_modules/css/lib/parse/index.js:260:26)
 *     at rule (node_modules/extract-from-css/node_modules/css/lib/parse/index.js:561:21)
 *     at rules (node_modules/extract-from-css/node_modules/css/lib/parse/index.js:118:70)
 *     at stylesheet (node_modules/extract-from-css/node_modules/css/lib/parse/index.js:81:21)
 *     at Object.module.exports [as parse] (node_modules/extract-from-css/.../index.js:565:20)
 *     at Function.extractClasses (node_modules/extract-from-css/lib/index.js:14:23)
 *     at processStyle (node_modules/vue-jest/lib/process-style.js:27:31)
 *     at node_modules/vue-jest/lib/process.js:93:13
 *         at Array.map (<anonymous>)
 * Test Suites: 1 failed, 1 total
 *
 * To address, simply ensure that an @media statement isn't the first rule-set as seen below.
 */
.main {
  display: block;
}

@media (min-width: max-width-x-large) {
  .main { display: flex; }
  .main > * { flex: 1; }
}
</style>
